import { Companion_getInstance2u620q9r4ejbj as Companion_getInstance } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Paint.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  get_dp28ag147e4p5cz as get_dp,
  get_rem14pbkv8p42gid as get_rem,
  times16x024lmmohdt as times,
  divc3x3x4wqw206 as div,
  get_rem2p56fiaxda5jo as get_rem_0,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { CornerRadii1b82t7ytilhrv as CornerRadii } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/CornerRadii.mjs';
import { Edges2jf5wl855ambv as Edges } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Rect.mjs';
import { Resources_getInstance22dnzrm1gxkf3 as Resources_getInstance } from '../Resources.js.mjs';
import { FontAndStyle1comk0qshc8kn as FontAndStyle } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import {
  Companion_getInstance2jahap30xtp3t as Companion_getInstance_0,
  toDuration28gf6ughsr3vf as toDuration,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { DurationUnit_SECONDS_getInstance162tnxlnf2fpv as DurationUnit_SECONDS_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import {
  OuterSemantic_getInstance3f4lrw2322ga8 as OuterSemantic_getInstance,
  override1oesdgz72e8ey as override,
  MainContentSemantic_getInstance31xiavoja82c3 as MainContentSemantic_getInstance,
  NavSemantic_getInstance3hcdsyfduq9gu as NavSemantic_getInstance,
  BarSemantic_getInstance1mitybcla04dq as BarSemantic_getInstance,
  FieldSemantic_getInstancer1p3l15xmphu as FieldSemantic_getInstance,
  ImportantSemantic_getInstancehm7lt56tp87l as ImportantSemantic_getInstance,
  DangerSemantic_getInstance1xd9zwrvs99lp as DangerSemantic_getInstance,
  AffirmativeSemantic_getInstance2svzxainpava5 as AffirmativeSemantic_getInstance,
  CardSemantic_getInstancelcny5le8pbc4 as CardSemantic_getInstance,
  PopoverSemantic_getInstanceyx37zl2h0qnj as PopoverSemantic_getInstance,
  HoverSemantic_getInstance3081oh8o0tv4w as HoverSemantic_getInstance,
  SelectedSemantic_getInstance3adr60xrkcq3z as SelectedSemantic_getInstance,
  HeaderSemantic_getInstance20a9id3sf7d4x as HeaderSemantic_getInstance,
  HeaderSizeSemantickc8o84qqqkjf as HeaderSizeSemantic,
  ButtonSemantic_getInstance3q30xblp6a1af as ButtonSemantic_getInstance,
  ListSemantic_getInstance2e62q1se6gw64 as ListSemantic_getInstance,
  _SemanticOverrides___init__impl__g2p3k812zbkczmal1zf as _SemanticOverrides___init__impl__g2p3k8,
  Themeex1jjdf3pz9y as Theme,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { IconButtonSemantic_getInstanceyhbmf43a1vw3 as IconButtonSemantic_getInstance } from './semantics.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_tcgTheme() {
  _init_properties_theme_kt__1225u1();
  return tcgTheme;
}
var tcgTheme;
var StyleTokensClass;
function StyleTokens() {
  if (StyleTokensClass === VOID) {
    class $ {
      constructor() {
        StyleTokens_instance = this;
        this.text_1 = Companion_getInstance().fromHexString_vb3go_k$('#1b2430');
        this.surface_1 = Companion_getInstance().fromHexString_vb3go_k$('#ffffff');
        this.primary_1 = Companion_getInstance().fromHexString_vb3go_k$('#0055a4');
        this.lightText_1 = Companion_getInstance().fromHexString_vb3go_k$('#ffffff');
        this.background_1 = Companion_getInstance().fromHexString_vb3go_k$('#16233a');
        this.appBackground_1 = Companion_getInstance().fromHexString_vb3go_k$('#f3f5f8');
        this.border_1 = Companion_getInstance().fromHexString_vb3go_k$('#d7dee6');
        this.danger_1 = Companion_getInstance().fromHexString_vb3go_k$('#B30838');
        this.success_1 = Companion_getInstance().fromHexString_vb3go_k$('#006225');
      }
    }
    initMetadataForObject($, 'StyleTokens');
    StyleTokensClass = $;
  }
  return StyleTokensClass;
}
var StyleTokens_instance;
function StyleTokens_getInstance() {
  if (StyleTokens_instance === VOID)
    new (StyleTokens())();
  return StyleTokens_instance;
}
function tcgTheme$lambda($this$override, it) {
  _init_properties_theme_kt__1225u1();
  return $this$override.withoutBack$default_y4jue9_k$(it, false, VOID, VOID, VOID, VOID, get_dp(0));
}
function tcgTheme$lambda_0($this$override, it) {
  _init_properties_theme_kt__1225u1();
  return $this$override.withBack$default_t8expd_k$(it, false, VOID, VOID, CornerRadii(get_dp(0)), VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, StyleTokens_getInstance().appBackground_1);
}
function tcgTheme$lambda_1($this$override, it) {
  _init_properties_theme_kt__1225u1();
  var tmp0_background = StyleTokens_getInstance().background_1;
  var tmp1_foreground = StyleTokens_getInstance().lightText_1;
  var tmp2_padding = Edges().new_com_lightningkite_kiteui_models_Edges_h2jw3i_k$(get_rem(0.5));
  return $this$override.withBack$default_t8expd_k$($this$override.alter$default_u3pj3s_k$(it, VOID, VOID, VOID, VOID, VOID, VOID, tmp2_padding, tmp1_foreground, VOID, VOID, VOID, VOID, tmp0_background), false, VOID, VOID, CornerRadii(get_dp(0)));
}
function tcgTheme$lambda_2($this$override, it) {
  _init_properties_theme_kt__1225u1();
  var tmp0_background = StyleTokens_getInstance().surface_1;
  var tmp1_iconOverride = StyleTokens_getInstance().primary_1;
  return $this$override.withBack$default_t8expd_k$($this$override.alter$default_u3pj3s_k$(it, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp1_iconOverride, VOID, VOID, VOID, tmp0_background), false, VOID, VOID, CornerRadii(get_dp(0)));
}
function tcgTheme$lambda_3($this$override, it) {
  _init_properties_theme_kt__1225u1();
  return $this$override.withBack$default_t8expd_k$(it, VOID, VOID, VOID, VOID, VOID, VOID, Edges().new_com_lightningkite_kiteui_models_Edges_h2jw3i_k$(get_rem(0.5)), VOID, VOID, StyleTokens_getInstance().border_1, get_dp(1));
}
function tcgTheme$lambda_4($this$override, it) {
  _init_properties_theme_kt__1225u1();
  var tmp0_background = StyleTokens_getInstance().primary_1;
  var tmp1_foreground = StyleTokens_getInstance().lightText_1;
  return $this$override.withBack$default_t8expd_k$(it, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp1_foreground, VOID, VOID, VOID, VOID, tmp0_background);
}
function tcgTheme$lambda_5($this$override, it) {
  _init_properties_theme_kt__1225u1();
  var tmp0_background = StyleTokens_getInstance().danger_1;
  var tmp1_foreground = StyleTokens_getInstance().lightText_1;
  return $this$override.withBack$default_t8expd_k$(it, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp1_foreground, VOID, VOID, VOID, VOID, tmp0_background);
}
function tcgTheme$lambda_6($this$override, it) {
  _init_properties_theme_kt__1225u1();
  var tmp0_background = StyleTokens_getInstance().success_1;
  var tmp1_foreground = StyleTokens_getInstance().lightText_1;
  return $this$override.withBack$default_t8expd_k$(it, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp1_foreground, VOID, VOID, VOID, VOID, tmp0_background);
}
function tcgTheme$lambda_7($this$override, it) {
  _init_properties_theme_kt__1225u1();
  return $this$override.withBack$default_t8expd_k$(it, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, get_dp(1));
}
function tcgTheme$lambda_8($this$override, it) {
  _init_properties_theme_kt__1225u1();
  return $this$override.withBack$default_t8expd_k$(it, false, VOID, get_dp(1));
}
function tcgTheme$lambda_9($this$override, it) {
  _init_properties_theme_kt__1225u1();
  var tmp0_background = it.background_1.map_p3tssl_k$(tcgTheme$lambda$lambda);
  var tmp1_outline = it.background_1.map_p3tssl_k$(tcgTheme$lambda$lambda_0);
  var tmp2_elevation = times(it.elevation_1, 2.0);
  return $this$override.withBack$default_t8expd_k$(it, VOID, VOID, tmp2_elevation, VOID, VOID, VOID, VOID, VOID, VOID, tmp1_outline, VOID, VOID, tmp0_background);
}
function tcgTheme$lambda$lambda(it) {
  _init_properties_theme_kt__1225u1();
  return it.highlight_bst4u4_k$(0.05);
}
function tcgTheme$lambda$lambda_0(it) {
  _init_properties_theme_kt__1225u1();
  return it.highlight_bst4u4_k$(0.2).highlight_bst4u4_k$(0.1);
}
function tcgTheme$lambda_10($this$override, it) {
  _init_properties_theme_kt__1225u1();
  var tmp0_background = it.background_1.map_p3tssl_k$(tcgTheme$lambda$lambda_1);
  var tmp1_outline = it.background_1.map_p3tssl_k$(tcgTheme$lambda$lambda_2);
  var tmp2_elevation = div(it.elevation_1, 2.0);
  return $this$override.withBack$default_t8expd_k$(it, VOID, VOID, tmp2_elevation, VOID, VOID, VOID, VOID, VOID, VOID, tmp1_outline, VOID, VOID, tmp0_background);
}
function tcgTheme$lambda$lambda_1(it) {
  _init_properties_theme_kt__1225u1();
  return it.highlight_bst4u4_k$(0.1);
}
function tcgTheme$lambda$lambda_2(it) {
  _init_properties_theme_kt__1225u1();
  return it.highlight_bst4u4_k$(0.2).highlight_bst4u4_k$(0.1);
}
function tcgTheme$lambda_11($this$override, it) {
  _init_properties_theme_kt__1225u1();
  return $this$override.withoutBack$default_y4jue9_k$(it, VOID, it.font_1.copy$default_cfilcw_k$(VOID, VOID, 700));
}
function tcgTheme$lambda_12($this$override, it) {
  _init_properties_theme_kt__1225u1();
  return $this$override.withoutBack$default_y4jue9_k$(it, VOID, it.font_1.copy$default_cfilcw_k$(VOID, VOID, VOID, VOID, VOID, VOID, get_dp(20)));
}
function tcgTheme$lambda_13($this$override, it) {
  _init_properties_theme_kt__1225u1();
  return $this$override.withoutBack$default_y4jue9_k$(it, VOID, it.font_1.copy$default_cfilcw_k$(VOID, VOID, VOID, VOID, VOID, VOID, get_dp(16)));
}
function tcgTheme$lambda_14($this$override, it) {
  _init_properties_theme_kt__1225u1();
  return $this$override.withoutBack$default_y4jue9_k$(it, VOID, it.font_1.copy$default_cfilcw_k$(VOID, VOID, VOID, VOID, VOID, VOID, get_dp(14)));
}
function tcgTheme$lambda_15($this$override, it) {
  _init_properties_theme_kt__1225u1();
  var tmp0_padding = Edges().new_com_lightningkite_kiteui_models_Edges_1f8j9i_k$(get_dp(14), get_dp(8));
  var tmp1_font = it.font_1.copy$default_cfilcw_k$(VOID, VOID, 600);
  var tmp2_outlineWidth = get_dp(1);
  return $this$override.withBack$default_t8expd_k$(it, VOID, tmp1_font, VOID, VOID, VOID, VOID, tmp0_padding, VOID, VOID, VOID, tmp2_outlineWidth);
}
function tcgTheme$lambda_16($this$override, it) {
  _init_properties_theme_kt__1225u1();
  var tmp0_padding = Edges().new_com_lightningkite_kiteui_models_Edges_h2jw3i_k$(get_dp(6));
  var tmp1_font = it.font_1.copy$default_cfilcw_k$(VOID, VOID, 600);
  var tmp2_outlineWidth = get_dp(1);
  return $this$override.withBack$default_t8expd_k$(it, VOID, tmp1_font, VOID, VOID, VOID, VOID, tmp0_padding, VOID, VOID, VOID, tmp2_outlineWidth);
}
function tcgTheme$lambda_17($this$override, it) {
  _init_properties_theme_kt__1225u1();
  var tmp0_gap = get_dp(2);
  return $this$override.withoutBack$default_y4jue9_k$(it, false, VOID, VOID, VOID, VOID, tmp0_gap);
}
var properties_initialized_theme_kt_vz0q7t;
function _init_properties_theme_kt__1225u1() {
  if (!properties_initialized_theme_kt_vz0q7t) {
    properties_initialized_theme_kt_vz0q7t = true;
    var tmp = new (FontAndStyle())(Resources_getInstance().publicsans_1, VOID, VOID, VOID, VOID, VOID, get_dp(14));
    var tmp_0 = get_dp(0);
    var tmp_1 = CornerRadii(get_dp(8));
    var tmp_2 = get_rem_0(1);
    var tmp_3 = Edges().new_com_lightningkite_kiteui_models_Edges_h2jw3i_k$(get_rem_0(1));
    var tmp_4 = StyleTokens_getInstance().text_1;
    var tmp_5 = StyleTokens_getInstance().border_1;
    var tmp_6 = StyleTokens_getInstance().border_1;
    var tmp_7 = StyleTokens_getInstance().surface_1;
    // Inline function 'kotlin.time.Companion.seconds' call
    Companion_getInstance_0();
    var tmp_8 = toDuration(0.1, DurationUnit_SECONDS_getInstance());
    var tmp_9 = OuterSemantic_getInstance();
    var tmp_10 = override(tmp_9, tcgTheme$lambda);
    var tmp_11 = MainContentSemantic_getInstance();
    var tmp_12 = override(tmp_11, tcgTheme$lambda_0);
    var tmp_13 = NavSemantic_getInstance();
    var tmp_14 = override(tmp_13, tcgTheme$lambda_1);
    var tmp_15 = BarSemantic_getInstance();
    var tmp_16 = override(tmp_15, tcgTheme$lambda_2);
    var tmp_17 = FieldSemantic_getInstance();
    var tmp_18 = override(tmp_17, tcgTheme$lambda_3);
    var tmp_19 = ImportantSemantic_getInstance();
    var tmp_20 = override(tmp_19, tcgTheme$lambda_4);
    var tmp_21 = DangerSemantic_getInstance();
    var tmp_22 = override(tmp_21, tcgTheme$lambda_5);
    var tmp_23 = AffirmativeSemantic_getInstance();
    var tmp_24 = override(tmp_23, tcgTheme$lambda_6);
    var tmp_25 = CardSemantic_getInstance();
    var tmp_26 = override(tmp_25, tcgTheme$lambda_7);
    var tmp_27 = PopoverSemantic_getInstance();
    var tmp_28 = override(tmp_27, tcgTheme$lambda_8);
    var tmp_29 = HoverSemantic_getInstance();
    var tmp_30 = override(tmp_29, tcgTheme$lambda_9);
    var tmp_31 = SelectedSemantic_getInstance();
    var tmp_32 = override(tmp_31, tcgTheme$lambda_10);
    var tmp_33 = HeaderSemantic_getInstance();
    var tmp_34 = override(tmp_33, tcgTheme$lambda_11);
    var tmp_35 = new (HeaderSizeSemantic())(1);
    var tmp_36 = override(tmp_35, tcgTheme$lambda_12);
    var tmp_37 = new (HeaderSizeSemantic())(2);
    var tmp_38 = override(tmp_37, tcgTheme$lambda_13);
    var tmp_39 = new (HeaderSizeSemantic())(3);
    var tmp_40 = override(tmp_39, tcgTheme$lambda_14);
    var tmp_41 = ButtonSemantic_getInstance();
    var tmp_42 = override(tmp_41, tcgTheme$lambda_15);
    var tmp_43 = IconButtonSemantic_getInstance();
    var tmp_44 = override(tmp_43, tcgTheme$lambda_16);
    var tmp_45 = ListSemantic_getInstance();
    tcgTheme = new (Theme())('tcgTheme', tmp, tmp_0, tmp_1, VOID, tmp_2, tmp_3, tmp_4, VOID, tmp_5, VOID, tmp_6, tmp_7, VOID, VOID, VOID, VOID, tmp_8, VOID, VOID, VOID, _SemanticOverrides___init__impl__g2p3k8([tmp_10, tmp_12, tmp_14, tmp_16, tmp_18, tmp_20, tmp_22, tmp_24, tmp_26, tmp_28, tmp_30, tmp_32, tmp_34, tmp_36, tmp_38, tmp_40, tmp_42, tmp_44, override(tmp_45, tcgTheme$lambda_17)]));
  }
}
//region block: exports
export {
  StyleTokens_getInstance as StyleTokens_getInstance3r0ikbe1r8w63,
  get_tcgTheme as get_tcgTheme1nse0bsqncjv0,
};
//endregion

//# sourceMappingURL=theme.mjs.map
